<div
  class="print-layout-toggle"
  [title]="checked ? 'Print layout' : 'Print without layout'"
>
  <span class="print-layout-label">Print layout</span>
  <mat-slide-toggle
    [checked]="checked"
    [disabled]="disabled"
    (change)="checkedChange.emit($event.checked)"
    [attr.data-test-id]="testId"
  ></mat-slide-toggle>
</div>
